export default __webpack_public_path__ + "static/media/057-owl.86ef0ac4.svg";